import { z } from "zod";
import { AddressSchema } from "./addresses";

export const LocationSchema = z.object({
  name: z.string(),
  address: AddressSchema,
  description: z.string().optional(),
  instructions: z.string().optional(),
  preferred_users: z.record(z.string()).optional(),
  banned_users: z.array(z.object({ id: z.string(), reason: z.string() })).optional(),
  requirements: z.array(z.string()).optional(),
});

export const LocationsSchema = z.array(LocationSchema).default([
  {
    name: "Paycom Center",
    address: {
      street: "100 W Reno Ave",
      city: "Oklahoma City",
      state: "OK",
      zip: "73102",
      type: "venue",
    },
    description: "Downtown multi-purpose arena, home of the OKC Thunder.",
    instructions: "Use employee entrance on the east side.",
  },
  {
    name: "Oklahoma State Fairgrounds",
    address: {
      street: "3001 General Pershing Blvd",
      city: "Oklahoma City",
      state: "OK",
      zip: "73107",
      type: "fairgrounds",
    },
    description: "Large event fairgrounds with multiple expo halls and arenas.",
    instructions: "Check in at Gate 3 security office.",
  },
  {
    name: "Civic Center Music Hall",
    address: {
      street: "201 N Walker Ave",
      city: "Oklahoma City",
      state: "OK",
      zip: "73102",
      type: "theatre",
    },
    description: "Performing arts center for Broadway shows, concerts, and local productions.",
    instructions: "Load-in via stage door on Couch Drive.",
  },
  {
    name: "BOK Center",
    address: {
      street: "200 S Denver Ave",
      city: "Tulsa",
      state: "OK",
      zip: "74103",
      type: "arena",
    },
    description: "Downtown Tulsa arena for concerts, sports, and large-scale events.",
    instructions: "Crew entrance on 3rd Street loading dock.",
  },
  {
    name: "Tulsa Performing Arts Center",
    address: {
      street: "110 E 2nd St",
      city: "Tulsa",
      state: "OK",
      zip: "74103",
      type: "theatre",
    },
    description: "Performing arts complex with multiple theatres and halls.",
    instructions: "Check in with stage manager at dock entrance on Cincinnati Ave.",
  },
]);
// export const LocationsSchema = z
//   .record(LocationSchema)
//   .refine((obj) => Object.keys(obj).every((k) => z.string().uuid().safeParse(k).success), {
//     message: "All keys must be valid UUIDs",
//   });
